module.exports = __webpack_public_path__ + "static/media/not-fee.b78ffe36.svg";